import dayjs, {Dayjs} from 'dayjs';
import {z as r} from 'zod';

export enum TelegramAnalyticsFieldsEnum {
    EventType = 'eventType',
    MessengerNotificationsTimeBucket = 'messengerNotificationsTimeBucket',
    InvitationLink = 'invitationLink',
    LanguageCode = 'languageCode',
    Timezone = 'timezone',
    NotificationTime = 'notificationTime',
}

const telegramAnalyticsFormSchema = r.object({
    [TelegramAnalyticsFieldsEnum.Timezone]: r.string(),
    [TelegramAnalyticsFieldsEnum.LanguageCode]: r.string(),
    [TelegramAnalyticsFieldsEnum.NotificationTime]: r.custom<Dayjs>((value) => value instanceof dayjs, 'Invalid date'),
});

export type TelegramAnalyticsFormType = r.infer<typeof telegramAnalyticsFormSchema>;
